import { useRef, FormEvent } from 'react';
import styled from 'styled-components';
import Image from 'next/image';
import { useDispatch } from 'src/store/store';
import config from 'config/config';
import i18n from 'src/utils/translate';
import { Category, useCookieCategory } from 'src/utils/cookie';
import { showLoginModal, showSignupModal } from 'src/modules/shared/modal/actions';
import SocialLoginButtons from 'src/modules/shared/modal/components/login/socialLoginButtons';
import Button from 'src/components/buttons/button';
import { LinkButton } from 'styles-js/buttons';
import { FadeBottom } from 'styles-js/mixins/fade';
import { titleLarge } from 'styles-js/mixins/typography';
import YouTubeEmbed from 'src/components/youTubeEmbed';
import { Video } from 'src/constants/youTube';
export default function SecondPageBlockMessageBox() {
  const dispatch = useDispatch();
  const emailRef = useRef<HTMLInputElement>(null);
  const [isFunctionalityAccepted] = useCookieCategory(Category.Functionality);
  const onSubmitEmail = (e: FormEvent<HTMLFormElement>): void => {
    const emailValue = emailRef.current ? emailRef.current.value : '';
    e.preventDefault();
    dispatch(showSignupModal({
      defaultEmail: emailValue
    }));
  };
  return <>
      <Container data-sentry-element="Container" data-sentry-source-file="secondPageBlockMessageBox.tsx">
        <Title data-sentry-element="Title" data-sentry-source-file="secondPageBlockMessageBox.tsx">{i18n.t('You need to join to keep reading')}</Title>
        <p>{i18n.t(`It's still free to read - this is not a paywall`)}</p>

        <DesktopLine data-sentry-element="DesktopLine" data-sentry-source-file="secondPageBlockMessageBox.tsx">
          <Form className="home__form" onSubmit={e => onSubmitEmail(e)} data-sentry-element="Form" data-sentry-source-file="secondPageBlockMessageBox.tsx">
            <input aria-label="Please enter your email address" className="form-control home__form-input home__form-input--small" data-testid="second-page-block-email-input" placeholder={i18n.t('email@address.com')} ref={emailRef} type="text" />
            <Button dataTestId="second-page-block-join-button" fullWidth={true} isSubmit={true} text={i18n.t('Join with email')} data-sentry-element="Button" data-sentry-source-file="secondPageBlockMessageBox.tsx" />
          </Form>
          <SocialContainer data-sentry-element="SocialContainer" data-sentry-source-file="secondPageBlockMessageBox.tsx">
            <WordWithLine data-sentry-element="WordWithLine" data-sentry-source-file="secondPageBlockMessageBox.tsx"><span>{i18n.t('OR')}</span></WordWithLine>
            <SocialLoginButtons data-sentry-element="SocialLoginButtons" data-sentry-source-file="secondPageBlockMessageBox.tsx" />
          </SocialContainer>
        </DesktopLine>

        <LoginText data-sentry-element="LoginText" data-sentry-source-file="secondPageBlockMessageBox.tsx">{i18n.t('Already a member?')} <LinkButton data-testid="second-page-block-login-button" onClick={() => dispatch(showLoginModal())} data-sentry-element="LinkButton" data-sentry-source-file="secondPageBlockMessageBox.tsx">{i18n.t('Log in')}</LinkButton></LoginText>
        <Title data-sentry-element="Title" data-sentry-source-file="secondPageBlockMessageBox.tsx">{i18n.t('Why join the largest social network for health?')}</Title>

        <DesktopLine data-sentry-element="DesktopLine" data-sentry-source-file="secondPageBlockMessageBox.tsx">
          <VideoContainer data-sentry-element="VideoContainer" data-sentry-source-file="secondPageBlockMessageBox.tsx">
            {isFunctionalityAccepted ? <YouTubeEmbed id={Video.HealthUnlocked} title="HealthUnlocked Video" /> : <a aria-label="Video HealthUnlocked The social network for health on Youtube" href={`https://www.youtube.com/watch?v=${Video.HealthUnlocked}`} rel="noreferrer" target="_blank">
                  <Image alt="Video HealthUnlocked The social network for health on Youtube" height={162} layout="responsive" src={`${config.cdn.static}img/visitor-block-message/video-fallback-img.jpg`} width={287} />
                </a>}
          </VideoContainer>
          <GetSupport data-sentry-element="GetSupport" data-sentry-source-file="secondPageBlockMessageBox.tsx">{i18n.t('Get 24/7 support from a community of like-minded people who share your health experiences. Ask questions, get answers and feel empowered on your unique journey.')}</GetSupport>
        </DesktopLine>

        <DesktopLine stretch={true} data-sentry-element="DesktopLine" data-sentry-source-file="secondPageBlockMessageBox.tsx">
          <Review data-sentry-element="Review" data-sentry-source-file="secondPageBlockMessageBox.tsx">
            <Stars alt={i18n.t('5 stars rating')} src={`${config.cdn.static}img/visitor-block-message/stars-green.svg`} data-sentry-element="Stars" data-sentry-source-file="secondPageBlockMessageBox.tsx" />
            <p>{i18n.t('"Health Unlocked is so many things to me. The friendships, information, support, all huge parts. Just wonderful."')}</p>
          </Review>
          <Review data-sentry-element="Review" data-sentry-source-file="secondPageBlockMessageBox.tsx">
            <Stars alt={i18n.t('5 stars rating')} src={`${config.cdn.static}img/visitor-block-message/stars-green.svg`} data-sentry-element="Stars" data-sentry-source-file="secondPageBlockMessageBox.tsx" />
            <p>{i18n.t('"HealthUnlocked has given me more confidence to question my condition and discuss it more with my doctors"')}</p>
          </Review>
        </DesktopLine>
      </Container>
      <MoreLinks data-sentry-element="MoreLinks" data-sentry-source-file="secondPageBlockMessageBox.tsx">
        {i18n.t('Please')}{' '}
        <LinkButton onClick={() => dispatch(showSignupModal())} data-sentry-element="LinkButton" data-sentry-source-file="secondPageBlockMessageBox.tsx">{i18n.t('join')}</LinkButton>
        {' ' + i18n.t('or') + ' '}
        <LinkButton onClick={() => dispatch(showLoginModal())} data-sentry-element="LinkButton" data-sentry-source-file="secondPageBlockMessageBox.tsx">{i18n.t('log in')}</LinkButton>
        {' '}{i18n.t('to continue reading')}
      </MoreLinks>
    </>;
}
const Container = styled.div`
  position: relative;
  padding: 10px 20px;
  background-color: ${({
  theme
}) => theme.colorBlueBackground};
  ${FadeBottom};

  @media (${({
  theme
}) => theme.underScreenSmall}) {
    padding: 5px 15px;
  }
`;
const Title = styled.p`
  ${titleLarge};
  padding-top: 10px;
  margin-bottom: 20px;

  &:last-of-type {
    @media (${({
  theme
}) => theme.overScreenSmall}) {
      font-size: ${({
  theme
}) => theme.fontSizeM};;
    }
  }
`;
const DesktopLine = styled.div<{
  stretch?: boolean;
}>`
  margin: 20px 0;
  display: flex;
  gap: 20px;
  align-items: center;

  @media (${({
  theme
}) => theme.underScreenMedium}) {
    flex-direction: column;
    &:first-of-type {
      gap: 0;
    }
  }

  ${props => props.stretch && `align-items: stretch`};
`;
const Form = styled.form`
  flex: 1;
  width: 100%;
`;
const SocialContainer = styled.div`
  flex: 1;
  width: 100%;
`;
const WordWithLine = styled.p`
  font-weight: ${({
  theme
}) => theme.fontWeightBold};
  line-height: 0.1em;
  margin: 20px 0;
  text-align: center;
  border-bottom: ${({
  theme
}) => theme.greyLine};

  @media (${({
  theme
}) => theme.overScreenMedium}) {
    display: none;
  }

  span {
    background: ${({
  theme
}) => theme.colorBlueBackground};
    padding: 0 10px;
  }
`;
const LoginText = styled.p`
  margin: 25px 0;
`;
const VideoContainer = styled.div`
  flex: 1;
  width: 100%;
`;
const GetSupport = styled.p`
  flex: 1;

  @media (${({
  theme
}) => theme.overScreenXlarge}) {
    font-size: ${({
  theme
}) => theme.fontSizeM};
    line-height: ${({
  theme
}) => theme.fontLineHeightM};
  }
`;
const Review = styled.div`
  padding: 15px;
  background-color: ${({
  theme
}) => theme.colorGreenLighter};
  text-align: center;
`;
const Stars = styled.img`
  margin-bottom: 5px;
`;
const MoreLinks = styled.p`
  margin-bottom: 60px;
  padding-top: 10px;
  background-color: ${({
  theme
}) => theme.colorWhite};

  @media (${({
  theme
}) => theme.underScreenMedium}) {
    border-top: ${({
  theme
}) => theme.greyLine};
  }
`;